import { ChangeDetectionStrategy, Component, computed, input, model, output, TemplateRef } from '@angular/core';
@Component({
  selector: 'u-list-box',
  templateUrl: './u-list-box.component.html',
  styleUrl: './u-list-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UListBoxComponent<T> {
  items = input<T[] | { label: string; items: T[] }[]>([]);
  labelField = input('name');
  group = input(false);
  itemTemplate = input<TemplateRef<any> | undefined>(undefined);
  groupTemplate = input<TemplateRef<any> | undefined>(undefined);
  listStyle = input<Record<string, string>>({ 'max-height': '100%' });
  selectOnFocus = input<boolean>();
  selectedItems = model<T[] | null>(null);
  groupTrack = input<string>(null);
  itemTrack = input<string>(null);

  selectedChange = output<{ items: T[] | null }>();

  flatItems = computed(() => {
    if (this.group() && (this.items() as { label: string; items: T[] }[])?.[0]?.items) {
      return (this.items() as { label: string; items: T[] }[])?.flatMap((parent) => parent.items);
    }
    return this.items();
  });

  onChangeEvent(): void {
    this.selectedChange.emit({ items: this.selectedItems() });
  }

  onFocus(item) {
    if (this.selectOnFocus()) {
      this.selectedItems.set([item]);
      this.selectedChange.emit({ items: this.selectedItems() });
    }
  }
}
